import styled from 'styled-components';

import { spaceXXL } from '@xing-com/tokens';

export const UpsellLayout = styled.div`
  margin-bottom: ${spaceXXL};
`;
